import React from "react"
import Modal from 'react-bootstrap/Modal'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import FeatherIcon from 'feather-icons-react';
import PropTypes from "prop-types"
import axios from "axios";


class SlackNotificationPreferences extends React.Component {

  state = {
    show: this.props.show,
    subscribable_events: this.props.subscribable_events
  }
  clickSlackNotificationPreferences = (event) => {
    this.setState({
      show: true
    });
  }

  clickClose = () => {
    this.setState({
      show: false
    });
  }

  clickSave = () => {
    const csrfToken = document.querySelector("meta[name=csrf-token]").content;
    var response = null;
    const saveSlackNotPrefRequest = async () => {
      response = await axios.put(
        `settings/notification_preferences/slack`,
        { subscribable_events: this.state.subscribable_events },
        { headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken } }
      )

      this.setState({
        show: false,
      });
    }
    saveSlackNotPrefRequest();
  }

  toggleSubscribableEvent = (event) => {
    var checkbox_id = parseInt(event.target.name.split("-")[2]);
    var event_items = this.state.subscribable_events;
    var selected_event_item  = event_items[checkbox_id];
    selected_event_item.checked = !selected_event_item.checked;
    event_items[checkbox_id] = selected_event_item
    this.setState({
      subscribable_events: event_items
    });
  }

  render () {
    return (
      <React.Fragment>
        <a className="dropdown-item" onClick={this.clickSlackNotificationPreferences}>Slack</a>
        <Modal 
          size="lg"
          show={this.state.show}
          backdrop="static"
          shouldCloseOnOverlayClick={true}
          centered>
          <Modal.Header>
            <Modal.Title>Slack Notification Preferences</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Container>
              <Row>
                <Col xs={12} md={12}>
                  <form>
                  <div className="action-control">
                  <h4>Event Subscriptions</h4>
                  {this.state.subscribable_events.map((subscribable_event, i) => (
                  	<React.Fragment>
                  	  <label className="event-checkbox">
                  	    <input type="checkbox" onChange={this.toggleSubscribableEvent} key={`subscribable-event-${i}`} name={`subscribable-event-${i}`} checked={subscribable_event.checked}/>
                  	    {`${subscribable_event.name} `}
                        <div className="form-tooltip">
                  	      <FeatherIcon icon="help-circle" className="mt-1"/>
                          <span className="form-tooltiptext">{subscribable_event.copy}</span>
                        </div>
                  	  </label>
                  	</React.Fragment>
                  ))}
                  </div>
                  <div className="actio-control mt-3">
                    <a href="https://slack.com/oauth/v2/authorize?scope=incoming-webhook&amp;user_scope=&amp;redirect_uri=https%3A%2F%2Fdynoscale.net%2Fdashboard%3Fslack_notification_preferences%3D1&amp;client_id=3040762397031.3055404784643" style={{display: this.props.config_url ? 'none' : 'inline-flex', alignItems: 'center', color: '#000', backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '4px', fontFamily: 'Lato, sans-serif', fontSize: '16px', fontWeight: 600, height: '48px', justifyContent: 'center', textDecoration: 'none', width: '236px'}}><svg xmlns="http://www.w3.org/2000/svg" style={{height: '20px', width: '20px', marginRight: '12px'}} viewBox="0 0 122.8 122.8"><path d="M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z" fill="#e01e5a" /><path d="M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z" fill="#36c5f0" /><path d="M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z" fill="#2eb67d" /><path d="M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z" fill="#ecb22e" /></svg>Connect to Slack</a>
                    <a href={this.props.config_url} style={{display: this.props.config_url ? 'inline-flex' : 'none',alignItems: 'center', color: '#000', backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '4px', fontFamily: 'Lato, sans-serif', fontSize: '16px', fontWeight: 600, height: '48px', justifyContent: 'center', textDecoration: 'none', width: '236px'}}><svg xmlns="http://www.w3.org/2000/svg" style={{height: '20px', width: '20px', marginRight: '12px'}} viewBox="0 0 122.8 122.8"><path d="M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z" fill="#e01e5a" /><path d="M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z" fill="#36c5f0" /><path d="M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z" fill="#2eb67d" /><path d="M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z" fill="#ecb22e" /></svg>Configure Slack</a>
                  </div>
                  </form>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.clickClose}>Close</Button>
            <Button variant="primary" onClick={this.clickSave}>Save Slack Notification Preferences</Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}
SlackNotificationPreferences.defaultProps = {
  config_url: "",
  subscribable_events: [],
  webhook_url: "",
  show: false
}


SlackNotificationPreferences.propTypes = {
  config_url: PropTypes.string,
  subscribable_events: PropTypes.array,
  webhook_url: PropTypes.string,
  show: PropTypes.boolean
};
export default SlackNotificationPreferences
